/* naawm / Nox — frise de livraison.
   Calcule les dates réelles côté client (jamais de dates figées en cache) :
   Expédié = aujourd'hui + N jours ouvrés · Chez vous = expédition + min/max jours ouvrés. */
(function () {
  if (window.__noxDelivery) return;
  window.__noxDelivery = true;

  function addBusinessDays(from, days) {
    var d = new Date(from);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function addCalendarDays(from, days) {
    var d = new Date(from);
    d.setDate(d.getDate() + days);
    return d;
  }

  var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });

  function init() {
    document.querySelectorAll('[data-nox-delivery]:not(.nox-dl-done)').forEach(function (el) {
      el.classList.add('nox-dl-done');
      var dispatchDays = parseInt(el.dataset.dispatch || '2', 10);
      var minDays = parseInt(el.dataset.min || '3', 10);
      var maxDays = parseInt(el.dataset.max || '6', 10);
      var business = el.dataset.business === 'true';
      var add = business ? addBusinessDays : addCalendarDays;

      var now = new Date();
      var dispatch = add(now, dispatchDays);
      var dMin = add(dispatch, minDays);
      var dMax = add(dispatch, maxDays);

      var dispatchEl = el.querySelector('[data-nox-date="dispatch"]');
      var deliveryEl = el.querySelector('[data-nox-date="delivery"]');
      if (dispatchEl) dispatchEl.textContent = fmt.format(dispatch);
      if (deliveryEl) deliveryEl.textContent = fmt.format(dMin) + ' – ' + fmt.format(dMax);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  /* Le volet panier est re-rendu en AJAX à chaque ajout : son HTML est remplacé,
     donc la frise repart « non traitée » → on relance le calcul à chaque mutation. */
  function surveillerPanier() {
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (!drawer || drawer.__noxObserved) return;
    drawer.__noxObserved = true;
    new MutationObserver(function () {
      init();
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') surveillerPanier();
  else document.addEventListener('DOMContentLoaded', surveillerPanier);
})();
